import React from 'react';
import AboutText from '../components/AboutComponents/AboutText';
import TextContentHeader from '../components/TextContent/TextContentHeader';
import ServicesDetailedheader from '../components/ServicesComponents/ServicesDetailedheader';
import CallToAction from '../components/Misc/CallToAction';
import Art from '../components/Misc/Art';
import TabsSection from '../components/Sections/TabsSection';
import illustration from '../assets/images/art_2.png';

import logo from '../assets/images/logo.png';
import servicesFooterImage from '../assets/images/services-footer1.jpg';

function Services() {
    return (
        <div className="services-page">
            <ServicesDetailedheader />
            <AboutText image={logo} content="We don’t follow a fixed process. Each project guides how we work, helping us stay focused on what needs to be built while adapting as we go." />

            <div className="text-content">
                <div className="text-content-wrapper position-relative bg-black">
                    <TextContentHeader heading="Capabilities built through experience." />

                    <div className="text-content-inner">
                        <TabsSection dark="true" />
                    </div>
                    <CallToAction 
                        wrapperClass='text-content-footer bg-black pt-0 pb-0'
                        headingClass='light-1'
                        heading={
                            <>
                                Have an idea?
                                <br />
                                Let’s explore it together.
                            </>
                        }
                        buttonText="Contact Us"
                        buttonLink="/Contact"
                        buttonType="1"
                    />
                    <Art art={illustration} type="2" />
                </div>
            </div>

            <div className="single-image ">
                <img src={servicesFooterImage} alt="generic" />
            </div>
        </div>
    );
}

export default Services;
